import React from 'react'
import TotalIncomePage from '../../components/Admin/TotalIncome';

const TotalIncome = () => {
  return (
    <TotalIncomePage />
  )
}

export default TotalIncome;